import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee02e7a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "experience-form" }
const _hoisted_2 = { class: "experience-form__company" }
const _hoisted_3 = ["selected"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "experience-form__location" }
const _hoisted_6 = { class: "experience-form__daterange" }
const _hoisted_7 = {
  class: "daterange",
  "data-testid": "experience-form_start-date"
}
const _hoisted_8 = {
  class: "daterange",
  "data-testid": "experience-form_end-date"
}
const _hoisted_9 = { class: "experience-form__actions" }
const _hoisted_10 = { class: "left-side-actions" }
const _hoisted_11 = { class: "right-side-actions" }

import {AddressResource} from '@/common/api/api-raw-types';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import LocationAutocomplete from '@/common/components/location-autocomplete/LocationAutocomplete.vue';
    import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';
    import {getCalendarProperties, useTranslation} from '@malt/vue3-use';
    import {computed, inject, onBeforeMount, reactive, ref, watch} from 'vue';
    import {ActivityArea, CompanySuggestion, Experience} from '../../../domain/experience/Experience';

    type ExperienceFormEvents = {
        (e: 'experience-form:cancel'): void;
        (e: 'experience-form:delete', experience: Experience): void;
        (e: 'experience-form:add', experience: Experience): void;
        (e: 'experience-form:update', experience: Experience): void;
    };
    type ExperienceFormState = {
        experience: Partial<Experience>;
        selectedCompanySuggestion?: CompanySuggestion;
    };

    type AutoCompleteCompleteEvent = {query: string};
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ExperienceForm',
  emits: ["experience-form:cancel", "experience-form:delete", "experience-form:add", "experience-form:update"],
  setup(__props, { emit: emits }) {

    const experienceDomainService = inject(DI.experienceDomainService);

    const {msg} = useTranslation();
    const {datePattern, datePatternRegex} = getCalendarProperties();

    

    const activityAreas = ref<ActivityArea[]>([]);
    const isLoading = ref(true);
    const isValidForm = ref(false);
    const companySuggestions = ref<CompanySuggestion[]>([]);
    const state = reactive<ExperienceFormState>({experience: {}});
    const isEnabledSaveButton = computed(() => isValidForm.value === true);
    const isEnabledEndDate = computed(() => state.experience.isCurrentJob !== true);

    const maxEndDate = new Date();
    const maxStartDate = computed(() => state.experience.endDate || maxEndDate);
    const minEndDate = computed(() => state.experience.startDate);

    onBeforeMount(async () => {
        activityAreas.value = await experienceDomainService!.fetchActivityAreas();
        isLoading.value = false;
    });

    watch(
        () => state.experience,
        async () => {
            isValidForm.value = experienceDomainService!.isValidExperience(state.experience);
        },
        {deep: true},
    );

    // Events handlers: buttons
    function handleCancel() {
        emits('experience-form:cancel');
    }

    function handleDelete() {
        emits('experience-form:delete', state.experience);
    }
    // Events handlers: form fields
    function handleFormAreaChange(e: CustomEvent) {
        state.experience.area = e.detail.value;
    }

    function handleFormAsFreelancerChange(e: CustomEvent) {
        state.experience.asFreelancer = e.detail;
    }
    // This event type should be replaced by the one from primevue...
    function handleFormCompanyComplete(e: AutoCompleteCompleteEvent) {
        searchCompanies(e.query);
    }
    function handleFormCompanyUpdate(value: CompanySuggestion | string) {
        // The AutoComplete returns a string when its updated without selecting a suggestion
        if (typeof value === 'string') {
            state.experience.companyId = '';
            state.experience.company = value;
        } else {
            state.experience.companyId = value.companyId;
            state.experience.company = value.name;
        }
    }
    function handleFormDescriptionChange(e: CustomEvent) {
        state.experience.description = e.detail.value;
    }
    function handleFormEndDateUpdate(value: Date) {
        state.experience.endDate = value;
    }
    function handleFormIsCurrentJobChange(e: CustomEvent) {
        state.experience.isCurrentJob = e.detail;

        if (state.experience.isCurrentJob === true) {
            state.experience.endDate = undefined;
        }
    }
    function handleFormLocationChange(value: AddressResource) {
        state.experience.location = value;
    }
    function handleFormTitleChange(event: CustomEvent) {
        state.experience.title = event.detail.value;
    }
    function handleFormStartDateUpdate(value: Date) {
        state.experience.startDate = value;
    }
    // Events handlers: form actions
    function handleValidate() {
        if (!state.experience.id) {
            emits('experience-form:add', state.experience);
        } else {
            emits('experience-form:update', state.experience);
        }
    }

    async function searchCompanies(query: string): Promise<void> {
        try {
            companySuggestions.value = await experienceDomainService!.searchCompanies(query);
        } catch (e) {
            displayTechnicalErrorNotification();
        }
    }

    function displayTechnicalErrorNotification() {
        pushNotification(msg('profile.creation.common.notification.error.technical'), {level: 'error'});
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_input = _resolveComponent("joy-input")!
  const _component_joy_checkbox = _resolveComponent("joy-checkbox")!
  const _component_joy_label = _resolveComponent("joy-label")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_joy_select = _resolveComponent("joy-select")!
  const _component_VJoyCalendar = _resolveComponent("VJoyCalendar")!
  const _component_joy_wrapper = _resolveComponent("joy-wrapper")!
  const _component_joy_textarea = _resolveComponent("joy-textarea")!
  const _component_joy_button = _resolveComponent("joy-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_joy_input, {
        required: true,
        value: state.experience.title,
        onJoyInputChange: handleFormTitleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(msg)('profile.new.experience.title')), 1)
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(_component_joy_checkbox, {
        value: state.experience.asFreelancer,
        checked: state.experience.asFreelancer,
        onJoyCheckboxChange: handleFormAsFreelancerChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(msg)('profile.section.experience.label.as.freelancer')), 1)
        ]),
        _: 1
      }, 8, ["value", "checked"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_joy_label, { required: "" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(msg)('profile.new.experience.company')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_AutoComplete, {
          modelValue: state.selectedCompanySuggestion,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((state.selectedCompanySuggestion) = $event)),
            handleFormCompanyUpdate
          ],
          "no-options-label": _unref(msg)('profile.creation.completion.wizard.languages.notfound'),
          suggestions: companySuggestions.value,
          optionLabel: "name",
          onComplete: handleFormCompanyComplete
        }, {
          option: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.option.name), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "no-options-label", "suggestions"])
      ]),
      _createVNode(_component_joy_select, {
        modelValue: state.experience.area,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.experience.area) = $event)),
        label: _unref(msg)('profile.new.experience.area.placeholder'),
        required: true,
        "required-mark": true,
        onJoySelectChange: handleFormAreaChange
      }, {
        default: _withCtx(() => [
          _createElementVNode("option", {
            disabled: "",
            selected: !state.experience.area
          }, _toDisplayString(_unref(msg)('profile.new.experience.area.placeholder')), 9, _hoisted_3),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityAreas.value, (activityArea) => {
            return (_openBlock(), _createElementBlock("option", {
              key: `activity-area_${activityArea.id}`,
              value: activityArea.id
            }, _toDisplayString(_unref(msg)(activityArea.translationKey)), 9, _hoisted_4))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "label"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_joy_label, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(msg)('profile.new.experience.location')), 1)
          ]),
          _: 1
        }),
        _createVNode(LocationAutocomplete, {
          required: true,
          address: state.selectedLocationAutocompleteAddress,
          "onUpdate:address": handleFormLocationChange
        }, null, 8, ["address"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_joy_checkbox, {
          value: state.experience.isCurrentJob,
          checked: state.experience.isCurrentJob,
          onJoyCheckboxChange: handleFormIsCurrentJobChange
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(msg)('profile.new.experience.job.still.in.progress')), 1)
          ]),
          _: 1
        }, 8, ["value", "checked"]),
        _createVNode(_component_joy_wrapper, { justify: "space-between" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_joy_label, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(msg)('profile.new.experience.first.date.label.new')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_VJoyCalendar, {
                "data-testid": "experience-form_start-date-calendar",
                datePattern: _unref(datePattern),
                datePatternRegex: _unref(datePatternRegex),
                modelValue: state.experience.startDate,
                required: true,
                maxDate: maxStartDate.value,
                "onUpdate:modelValue": handleFormStartDateUpdate
              }, null, 8, ["datePattern", "datePatternRegex", "modelValue", "maxDate"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_joy_label, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(msg)('profile.new.experience.second.date.label.new')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_VJoyCalendar, {
                "data-testid": "experience-form_start-date-calendar",
                disabled: !isEnabledEndDate.value,
                required: isEnabledEndDate.value,
                maxDate: _unref(maxEndDate),
                minDate: minEndDate.value,
                datePattern: _unref(datePattern),
                datePatternRegex: _unref(datePatternRegex),
                modelValue: state.experience.endDate,
                "onUpdate:modelValue": handleFormEndDateUpdate
              }, null, 8, ["disabled", "required", "maxDate", "minDate", "datePattern", "datePatternRegex", "modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_joy_textarea, {
          required: true,
          autogrow: "",
          value: state.experience.description,
          onJoyTextareaChange: handleFormDescriptionChange
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_joy_button, {
          class: "delete",
          variant: "ghost",
          onClick: handleDelete
        }, {
          default: _withCtx(() => [
            _createTextVNode("Delete")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_joy_button, {
          variant: "secondary",
          onClick: handleCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }),
        _createVNode(_component_joy_button, {
          variant: "primary",
          disabled: !isEnabledSaveButton.value,
          loading: isLoading.value,
          onClick: handleValidate
        }, {
          default: _withCtx(() => [
            _createTextVNode("Validate")
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ])
  ]))
}
}

})